import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import SupportVisualisationEmbeddedApiMessages from 'widgets/supportVisualisation/Content/EmbeddedApi/SupportVisualisationEmbeddedApiMessages';
import React from 'react';
import { Tab } from '@instinet-analytics/semantic-ui-components';
import './SupportVisualisationEmbeddedApi.scss';
import { SupportVisualisationEmbeddedApiSubscribers } from 'widgets/supportVisualisation/Content/EmbeddedApi/SupportVisualisationEmbeddedApiSubscribers';

export default function SupportVisualisationEmbeddedApi(
    props: VisualisationContextProps
) {
    const panes: { menuItem: string; render: () => JSX.Element }[] = [];

    const detailProps = { ...props, height: props.height - 40 };

    const renderMessages = () => (
        <SupportVisualisationEmbeddedApiMessages {...detailProps} />
    );
    panes.push({
        menuItem: 'Messages',
        render: renderMessages,
    });

    const renderSubscribers = () => (
        <SupportVisualisationEmbeddedApiSubscribers {...detailProps} />
    );
    panes.push({
        menuItem: 'Subscribers',
        render: renderSubscribers,
    });

    return (
        <div className="SupportVisualisationEmbeddedApi">
            <Tab
                panes={panes}
                menu={{ secondary: true, pointing: true, inverted: true }}
            />
        </div>
    );
}
